import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Script } from 'src/app/interfaces/script';
import { URL } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class RunScriptModalService {
  readonly http = inject(HttpClient);

  addScript(applicationId: number, script: Script): Observable<any> {
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(script);
    return this.http.put(`${URL.url}${URL.applications}/${applicationId}/script`, body, { headers });
  }
}
